import api from "./api";
import { OVERVIEW_URL } from "./api";

/**
 * Active post counts per category, for the Overview bar chart.
 * GET https://todaytalks.mpdatahub.com/api/talks/overview
 * Returns { total_active, category_counts: [{ category_id, category_name, count, image_url }, ...] }
 */
export async function fetchActiveCounts() {
  const res = await api.get(OVERVIEW_URL);
  const payload = res.data?.data || {};
  const counts = Array.isArray(payload.category_counts) ? payload.category_counts : [];

  // Keyed by category_id so it can be merged straight onto categories
  // fetched from the categories API (id, name, image, status).
  const countsByCategoryId = counts.reduce((acc, item) => {
    acc[item.category_id] = item.count;
    return acc;
  }, {});

  return {
    totalActive: payload.total_active ?? 0,
    countsByCategoryId,
  };
}